import "./App.css";
import Login from "./components/Login/Login";
// import Navbar from "./components/NavBar/Navbar";
import { Routes, Route } from "react-router-dom";
import UserDashboard from "./components/DashBoard/userDashboard";
import Chalan from "./components/Chalan/Chalan";
import Profiles from "./components/Profiles/Profiles";
import Trucks from "./components/Trucks/Truck";
import Clients from "./components/Clients/Clients";
import Drivers from "./components/Drivers/Drivers";
import Bilty from "./components/BiltyForm/Bilty";
import GenerateChalan from "./components/Chalan/GenerateChalan";
import LocalChalan from "./components/Chalan/LocalChalan";
import Chalans from "./components/Chalan/Chalans";
import EwayBill from "./components/EwayBill";
import EwayBillAuth from "./components/EwayBillAuth/EwayBillAuth";
import ShowingChallans from "./components/Invoice/ShowingChallans";
import MainChallans from "./components/Invoice/MainChallans";
import Local from "./components/Invoice/Local";
import Bilties from "./components/Invoice/Bilties";
import Ewayform from "./components/Invoice/Ewayform";
import ShowProfile from "./components/ShowProfile/ShowProfile";
import EditTruck from "./components/Trucks/EditTruck";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Login />{" "}
            </>
          }
        />
        <Route path="/dashbaord" element={<UserDashboard />}>
          <Route path="chalan" element={<Chalan />}>
            <Route path="chalans" element={<Chalans />} />
            <Route path="generatechalan" element={<GenerateChalan />} />
            <Route path="ewaybill" element={<EwayBill />} />
            <Route path="localchalan" element={<LocalChalan />} />
            <Route path="ewaybillauth" element={<EwayBillAuth />} />
          </Route>
          <Route path="profiles" element={<Profiles />} />
          <Route path="trucks" element={<Trucks />} />
          <Route path="edittrucks" element={<EditTruck />} />
          <Route path="clients" element={<Clients />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="bilty" element={<Bilty />} />
          <Route path="invoice" element={<ShowingChallans />} />
          <Route path="mainchallans" element={<MainChallans />} />
          <Route path="localchallans" element={<Local />} />
          <Route path="bilties" element={<Bilties />} />
          <Route path="ewayforms" element={<Ewayform />} />
          <Route path="myprofile" element={<ShowProfile />} />

          {/* <Route path="ewaybill" element={<EwayBill />} /> */}
          {/* <Route path="ewaybillauth" element={<EwayBillAuth />} /> */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
